import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import "./styles.scss";

/**
 * Use spacer to avoid issue with resizing when Table is wider than all Columns width
 */
const ColumnSpacer = ({ as: Component }) => (
  <Component className={classNames("mydpd-dnd-column-spacer")} />
);

ColumnSpacer.propTypes = {
  as: PropTypes.string,
};

ColumnSpacer.defaultProps = {
  as: "div",
};

export default ColumnSpacer;
